import request from '../utils/request';

export function getSerialList(params) {
    return request({
        url: '/serial/list',
        method: 'get',
        params
    });
}

export function importSerial(data) {
    return request({
        url: '/serial/import',
        method: 'post',
        data
    });
}

export function importOldSerial(data) {
    return request({
        url: '/serial/import-old',
        method: 'post',
        data
    });
}

export function getImportRecords(params) {
    return request({
        url: '/serial/import-records',
        method: 'get',
        params
    });
}

export function deleteSerial(data) {
    return request({
        url: '/serial/delete',
        method: 'post',
        data
    });
}

export function rebindSerial(data) {
    return request({
        url: '/serial/rebind',
        method: 'post',
        data
    });
}

export function getVoidRecords(params) {
    return request({
        url: '/serial/void-records',
        method: 'get',
        params
    });
}

export function getUnbindRecords(params) {
    return request({
        url: '/serial/unbind-records',
        method: 'get',
        params
    });
}

export function getResetRecords(params) {
    return request({
        url: '/serial/reset-records',
        method: 'get',
        params
    });
}

export function shipmentDeclare(data) {
    return request({
        url: '/serial/shipment',
        method: 'post',
        data
    });
}

export function getShipmentRecords(params) {
    return request({
        url: '/serial/shipment-records',
        method: 'get',
        params
    });
}

export function returnDeclare(data) {
    return request({
        url: '/serial/return',
        method: 'post',
        data
    });
}

export function getReturnRecords(params) {
    return request({
        url: '/serial/return-records',
        method: 'get',
        params
    });
}
